/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CustomRolePermissionDTO } from '../model/customRolePermissionDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CustomRolePermissionResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countCustomRolePermissions
     * 
     * @param allViewEquals 
     * @param allViewIn 
     * @param allViewNotEquals 
     * @param allViewSpecified 
     * @param filteredEquals 
     * @param filteredIn 
     * @param filteredNotEquals 
     * @param filteredSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param permissionCodeContains 
     * @param permissionCodeDoesNotContain 
     * @param permissionCodeEquals 
     * @param permissionCodeIn 
     * @param permissionCodeNotEquals 
     * @param permissionCodeSpecified 
     * @param roleIdEquals 
     * @param roleIdGreaterThan 
     * @param roleIdGreaterThanOrEqual 
     * @param roleIdIn 
     * @param roleIdLessThan 
     * @param roleIdLessThanOrEqual 
     * @param roleIdNotEquals 
     * @param roleIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (allViewEquals !== undefined && allViewEquals !== null) {
            queryParameters = queryParameters.set('allView.equals', <any>allViewEquals);
        }
        if (allViewIn) {
            allViewIn.forEach((element) => {
                queryParameters = queryParameters.append('allView.in', <any>element);
            })
        }
        if (allViewNotEquals !== undefined && allViewNotEquals !== null) {
            queryParameters = queryParameters.set('allView.notEquals', <any>allViewNotEquals);
        }
        if (allViewSpecified !== undefined && allViewSpecified !== null) {
            queryParameters = queryParameters.set('allView.specified', <any>allViewSpecified);
        }
        if (filteredEquals !== undefined && filteredEquals !== null) {
            queryParameters = queryParameters.set('filtered.equals', <any>filteredEquals);
        }
        if (filteredIn) {
            filteredIn.forEach((element) => {
                queryParameters = queryParameters.append('filtered.in', <any>element);
            })
        }
        if (filteredNotEquals !== undefined && filteredNotEquals !== null) {
            queryParameters = queryParameters.set('filtered.notEquals', <any>filteredNotEquals);
        }
        if (filteredSpecified !== undefined && filteredSpecified !== null) {
            queryParameters = queryParameters.set('filtered.specified', <any>filteredSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (permissionCodeContains !== undefined && permissionCodeContains !== null) {
            queryParameters = queryParameters.set('permissionCode.contains', <any>permissionCodeContains);
        }
        if (permissionCodeDoesNotContain !== undefined && permissionCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('permissionCode.doesNotContain', <any>permissionCodeDoesNotContain);
        }
        if (permissionCodeEquals !== undefined && permissionCodeEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.equals', <any>permissionCodeEquals);
        }
        if (permissionCodeIn) {
            permissionCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('permissionCode.in', <any>element);
            })
        }
        if (permissionCodeNotEquals !== undefined && permissionCodeNotEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.notEquals', <any>permissionCodeNotEquals);
        }
        if (permissionCodeSpecified !== undefined && permissionCodeSpecified !== null) {
            queryParameters = queryParameters.set('permissionCode.specified', <any>permissionCodeSpecified);
        }
        if (roleIdEquals !== undefined && roleIdEquals !== null) {
            queryParameters = queryParameters.set('roleId.equals', <any>roleIdEquals);
        }
        if (roleIdGreaterThan !== undefined && roleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('roleId.greaterThan', <any>roleIdGreaterThan);
        }
        if (roleIdGreaterThanOrEqual !== undefined && roleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.greaterThanOrEqual', <any>roleIdGreaterThanOrEqual);
        }
        if (roleIdIn) {
            roleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('roleId.in', <any>element);
            })
        }
        if (roleIdLessThan !== undefined && roleIdLessThan !== null) {
            queryParameters = queryParameters.set('roleId.lessThan', <any>roleIdLessThan);
        }
        if (roleIdLessThanOrEqual !== undefined && roleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.lessThanOrEqual', <any>roleIdLessThanOrEqual);
        }
        if (roleIdNotEquals !== undefined && roleIdNotEquals !== null) {
            queryParameters = queryParameters.set('roleId.notEquals', <any>roleIdNotEquals);
        }
        if (roleIdSpecified !== undefined && roleIdSpecified !== null) {
            queryParameters = queryParameters.set('roleId.specified', <any>roleIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/custom-role-permissions/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createCustomRolePermission
     * 
     * @param body customRolePermissionDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCustomRolePermissionUsingPOST(body: CustomRolePermissionDTO, observe?: 'body', reportProgress?: boolean): Observable<CustomRolePermissionDTO>;
    public createCustomRolePermissionUsingPOST(body: CustomRolePermissionDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomRolePermissionDTO>>;
    public createCustomRolePermissionUsingPOST(body: CustomRolePermissionDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomRolePermissionDTO>>;
    public createCustomRolePermissionUsingPOST(body: CustomRolePermissionDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createCustomRolePermissionUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CustomRolePermissionDTO>('post',`${this.basePath}/api/custom-role-permissions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteCustomRolePermission
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCustomRolePermissionUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCustomRolePermissionUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCustomRolePermissionUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCustomRolePermissionUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteCustomRolePermissionUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/custom-role-permissions/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllCustomRolePermissions
     * 
     * @param allViewEquals 
     * @param allViewIn 
     * @param allViewNotEquals 
     * @param allViewSpecified 
     * @param filteredEquals 
     * @param filteredIn 
     * @param filteredNotEquals 
     * @param filteredSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param page Page number of the requested page
     * @param permissionCodeContains 
     * @param permissionCodeDoesNotContain 
     * @param permissionCodeEquals 
     * @param permissionCodeIn 
     * @param permissionCodeNotEquals 
     * @param permissionCodeSpecified 
     * @param roleIdEquals 
     * @param roleIdGreaterThan 
     * @param roleIdGreaterThanOrEqual 
     * @param roleIdIn 
     * @param roleIdLessThan 
     * @param roleIdLessThanOrEqual 
     * @param roleIdNotEquals 
     * @param roleIdSpecified 
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomRolePermissionDTO>>;
    public getAllCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomRolePermissionDTO>>>;
    public getAllCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomRolePermissionDTO>>>;
    public getAllCustomRolePermissionsUsingGET(allViewEquals?: boolean, allViewIn?: Array<boolean>, allViewNotEquals?: boolean, allViewSpecified?: boolean, filteredEquals?: boolean, filteredIn?: Array<boolean>, filteredNotEquals?: boolean, filteredSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (allViewEquals !== undefined && allViewEquals !== null) {
            queryParameters = queryParameters.set('allView.equals', <any>allViewEquals);
        }
        if (allViewIn) {
            allViewIn.forEach((element) => {
                queryParameters = queryParameters.append('allView.in', <any>element);
            })
        }
        if (allViewNotEquals !== undefined && allViewNotEquals !== null) {
            queryParameters = queryParameters.set('allView.notEquals', <any>allViewNotEquals);
        }
        if (allViewSpecified !== undefined && allViewSpecified !== null) {
            queryParameters = queryParameters.set('allView.specified', <any>allViewSpecified);
        }
        if (filteredEquals !== undefined && filteredEquals !== null) {
            queryParameters = queryParameters.set('filtered.equals', <any>filteredEquals);
        }
        if (filteredIn) {
            filteredIn.forEach((element) => {
                queryParameters = queryParameters.append('filtered.in', <any>element);
            })
        }
        if (filteredNotEquals !== undefined && filteredNotEquals !== null) {
            queryParameters = queryParameters.set('filtered.notEquals', <any>filteredNotEquals);
        }
        if (filteredSpecified !== undefined && filteredSpecified !== null) {
            queryParameters = queryParameters.set('filtered.specified', <any>filteredSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (permissionCodeContains !== undefined && permissionCodeContains !== null) {
            queryParameters = queryParameters.set('permissionCode.contains', <any>permissionCodeContains);
        }
        if (permissionCodeDoesNotContain !== undefined && permissionCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('permissionCode.doesNotContain', <any>permissionCodeDoesNotContain);
        }
        if (permissionCodeEquals !== undefined && permissionCodeEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.equals', <any>permissionCodeEquals);
        }
        if (permissionCodeIn) {
            permissionCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('permissionCode.in', <any>element);
            })
        }
        if (permissionCodeNotEquals !== undefined && permissionCodeNotEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.notEquals', <any>permissionCodeNotEquals);
        }
        if (permissionCodeSpecified !== undefined && permissionCodeSpecified !== null) {
            queryParameters = queryParameters.set('permissionCode.specified', <any>permissionCodeSpecified);
        }
        if (roleIdEquals !== undefined && roleIdEquals !== null) {
            queryParameters = queryParameters.set('roleId.equals', <any>roleIdEquals);
        }
        if (roleIdGreaterThan !== undefined && roleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('roleId.greaterThan', <any>roleIdGreaterThan);
        }
        if (roleIdGreaterThanOrEqual !== undefined && roleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.greaterThanOrEqual', <any>roleIdGreaterThanOrEqual);
        }
        if (roleIdIn) {
            roleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('roleId.in', <any>element);
            })
        }
        if (roleIdLessThan !== undefined && roleIdLessThan !== null) {
            queryParameters = queryParameters.set('roleId.lessThan', <any>roleIdLessThan);
        }
        if (roleIdLessThanOrEqual !== undefined && roleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.lessThanOrEqual', <any>roleIdLessThanOrEqual);
        }
        if (roleIdNotEquals !== undefined && roleIdNotEquals !== null) {
            queryParameters = queryParameters.set('roleId.notEquals', <any>roleIdNotEquals);
        }
        if (roleIdSpecified !== undefined && roleIdSpecified !== null) {
            queryParameters = queryParameters.set('roleId.specified', <any>roleIdSpecified);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CustomRolePermissionDTO>>('get',`${this.basePath}/api/custom-role-permissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getCustomRolePermission
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCustomRolePermissionUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<CustomRolePermissionDTO>;
    public getCustomRolePermissionUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomRolePermissionDTO>>;
    public getCustomRolePermissionUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomRolePermissionDTO>>;
    public getCustomRolePermissionUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getCustomRolePermissionUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CustomRolePermissionDTO>('get',`${this.basePath}/api/custom-role-permissions/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateCustomRolePermission
     * 
     * @param body customRolePermissionDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCustomRolePermissionUsingPUT(body: CustomRolePermissionDTO, observe?: 'body', reportProgress?: boolean): Observable<CustomRolePermissionDTO>;
    public updateCustomRolePermissionUsingPUT(body: CustomRolePermissionDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomRolePermissionDTO>>;
    public updateCustomRolePermissionUsingPUT(body: CustomRolePermissionDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomRolePermissionDTO>>;
    public updateCustomRolePermissionUsingPUT(body: CustomRolePermissionDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateCustomRolePermissionUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CustomRolePermissionDTO>('put',`${this.basePath}/api/custom-role-permissions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
